import * as React from "react";
import Drawer from "@mui/material/Drawer";
import {
  ContainerDrawyer,
  HeaderBar,
  NotificationBox,
} from "./styled/Drawyer.styled";

export default function Drawyer({
  open,
  setOpen,
  notifications,
  setNotifications,
  setNotificationCount,
  ...props
}) {

  const onCloseDrawer = ()=>{
    setOpen(false);
    setNotificationCount(0);
    setNotifications([]);
  }

  return (
    <div>
      <Drawer
        anchor={"right"}
        open={open}
        onClose={onCloseDrawer}
      >
        <ContainerDrawyer>
          <HeaderBar>Notifications</HeaderBar>
          {notifications.map((noti, index) => {
            return (
              <>
                <NotificationBox key={index}>{noti.message}</NotificationBox>
              </>
            );
          })}
        </ContainerDrawyer>
      </Drawer>
    </div>
  );
}
